export default class Metric {
  #entityId;
  #data;

  constructor(entityId, data) {
    this.#entityId = entityId;
    this.#data = data;
  }

  get name(){
    return this.constructor.name;
  }

  get entityId(){
    return this.#entityId;
  }

  get data(){
    return this.#data;
  }
}
